<style lang="scss" src="./style.scss" scoped></style>
<script src="./script"></script>
<template>
  <breadcrumb :links="breadcrumb"></breadcrumb>
  <div class="page page-list">
    <div class="page-header p-3">
      <div class="header-control">
        <div>
          <h1 class="text-warning">Quản lí users</h1>
        </div>
        <div>
          <div class="search-query">
            <input type="text" class="form-control form-control-sm" placeholder="Nhập từ khóa tìm kiếm của bạn"
              v-model="filter.q" @change="onChangeFilter('q')">
          </div>
          <filter-dropdown class="mx-1" :badge="countFilter">
            <div class="filter-content p-3">
              <div class="search-query-sm mb-3">
                <input type="text" class="form-control form-control-sm" placeholder="Nhập từ khóa tìm kiếm của bạn"
                  v-model="filter.q" @change="onChangeFilter('q')">
              </div>
              <!-- <h6>Trạng thái hoạt động:</h6>
              <div class="d-flex mb-3">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" :checked="filter.active.includes(0)"
                    @change="onChangeFilter('active', $event, 0)" id="filter-active-off"> <label
                    for="filter-active-off">Không hoạt động</label>
                </div>

                <div class="form-check mx-2">
                  <input class="form-check-input" type="checkbox" :checked="filter.active.includes(1)"
                    @change="onChangeFilter('active', $event, 1)" id="filter-active-on"> <label
                    for="filter-active-on">Hoạt động</label>
                </div>
              </div> -->
              <div class="row">
                <div class="col col-12 mb-3">
                  <h6>Team:</h6>
                  <div>
                    <multi-select :mappingKeys="{ label: 'name', value: 'id' }"
                      type="string" :data="master.teams" label="Team" v-model="filter.team" :style="{ width: '100%' }"
                      @update:modelValue="onChangeFilter('team')"></multi-select>
                  </div>
                </div>
              </div>
              <div class="mt-3" style="text-align: right; font-weight: bold;"><a href="javascript: void(0)"
                  @click="resetFilter()"><i class="fa fa-trash"></i> Bộ lộc mặc định</a></div>
            </div>
          </filter-dropdown>
          <group-dropdown label="Hành động" icon="fa fa-list">
            <button class="btn btn-sm btn-success" @click="openModalCreate()"><i class="fa fa-plus"></i> Tạo mới</button>
            <button class="btn btn-sm btn-danger" @click="onDelete()" :disabled="checkedlist.length == 0"><i
                class="fa fa-trash"></i> Xóa ({{ checkedlist.length }})</button>
          </group-dropdown>
          <!-- <button class="btn btn-sm btn-danger"><i class="fa fa-trash"></i> Delete</button> -->
          <!-- <button class="btn btn-sm btn-warning" @click="openModalReason()" :disabled="checkedlist.length == 0"><i
              class="fa fa-lock"></i> Lock ({{ checkedlist.length }})</button>
          <button class="btn btn-sm btn-info" @click="onUnlock()" :disabled="checkedlist.length == 0"><i
              class="fa fa-unlock"></i> Active ({{ checkedlist.length }})</button> -->
        </div>
      </div>
    </div>
    <overlay class="page-body px-3" :loading="isSearching">
      <div class="table-responsive">
        <table class="table fixed-left fixed-right table-striped" v-if="result">
          <thead>
            <tr>
              <th>
                <div class="form-check" v-if="result.data.length">
                  <input class="form-check-input" type="checkbox" @click="checkall()"
                    :checked="checkedlist.length == result.data.length">
                </div>
              </th>
              <th></th>
              <th>Tên hiển thị</th>
              <th>Email</th>
              <th>Team</th>
              <th>Vai trò</th>
              <th>2FA</th>
              <th class="action"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(account, i) in result.data" :key="i">
              <td>
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" @click="toggleCheckbox(account.id)"
                    :checked="checkedlist.includes(account.id)">
                </div>
              </td>
              <td><i v-if="account.is_admin" class="fa-solid fa-screwdriver-wrench text-success"></i><i v-if="account.role == 'MANAGER'" class="fa-solid fa-user-tie text-warning"></i></td>
              <td>{{ account.name }}</td>
              <td>{{ account.email }}</td>
              <td><span v-if="account.team">{{ account.team.name }}</span><span v-else>-</span></td>
              <td><span v-if="account.is_admin">ADMIN</span><span v-else>{{ account.role }}</span></td>
              <td>
                <i class="fa fa-check-circle"
                  :class="{ 'text-secondary': !account.two_factor_confirmed_at, 'text-success': account.two_factor_confirmed_at }"></i>
                <span class="text-success" v-if="account.two_factor_confirmed_at"> Đã xác thực <a
                    href="javascript: void(0)" @click="onConfirmRemove2Fa(account)"><i
                      class="fa fa-remove text-danger"></i></a></span>
                <span class="text-secondary" v-else> Chưa xác thực</span>
              </td>
              <td class="action">
                <a href="javascript: void(0)" @click="openModalUpdate(account)"><i class="fa fa-edit"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="py-2 px-3" v-if="result && result.data.length == 0">
          Không có dữ liệu
        </div>
      </div>
    </overlay>

    <div class="page-footer p-3">
      <div v-if="result">
        Hiển thị {{ result.data.length }} ({{ result.from }} - {{ result.to }})/{{ result.total }}, Trang {{
          result.current_page }}/{{ result.last_page }} | {{ checkedlist.length }} được chọn
      </div>
      <b-pagination :data="result" v-if="result" @change="onChangePage"></b-pagination>
    </div>
  </div>

  <b-modal ref="crudModal">
    <div class="modal-header">
      <h5 class="modal-title" v-if="this.crudForm.id"><i class="fa fa-edit"></i> Chỉnh sửa thông tin user</h5>
      <h5 class="modal-title" v-else><i class="fa fa-pencil"></i> Tạo mới user</h5>
      <button type="button" class="btn btn-cls" data-bs-dismiss="modal"><i class="fa fa-remove"></i></button>
    </div>

    <div class="modal-body">
      <!-- <textarea class="form-control" v-model="lockedMessage"></textarea> -->
      <div class="mb-3">
        <label>Tên hiển thị</label>
        <input class="form-control" type="text" placeholder="Tên hiển thị" v-model="crudForm.name"
          :class="{ 'border-danger': crudForm.errors.name }" />
        <div class="msg-error" v-if="crudForm.errors.name">{{ crudForm.errors.name[0] }}</div>
      </div>

      <div class="mb-3">
        <label>Email</label>
        <input class="form-control" type="text" placeholder="Email" v-model="crudForm.email"
          :class="{ 'border-danger': crudForm.errors.email }" />
        <div class="msg-error" v-if="crudForm.errors.email">{{ crudForm.errors.email[0] }}</div>
      </div>

      <div class="mb-3">
        <label>Mật khẩu</label>
        <div class="input-group">
          <input class="form-control" type="text" placeholder="Nhập mật khẩu" v-model="crudForm.password"
            :class="{ 'border-danger': crudForm.errors.password }" />
          <button class="btn btn-success" @click="onRandomPassword()"><i class="fa fa-refresh"></i></button>
        </div>
        <div class="msg-error" v-if="crudForm.errors.password">{{ crudForm.errors.password[0] }}</div>
        <div class="des" v-if="this.crudForm.id"><i>* Vui lòng để trống nếu không muốn thay đổi mật khẩu</i></div>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="checkbox" v-model="crudForm.is_admin" :checked="crudForm.is_admin"
        id="is_admin" @change="onChangeIsAdmin()"> <label for="is_admin">Admin hệ thống</label>
    </div>

    <div class="mb-3" v-if="!crudForm.is_admin">
      <label>Vai trò</label>
      <select v-model="crudForm.role" class="form-control" :class="{ 'border-danger': crudForm.errors.role }">
        <option value="MANAGER">MANAGER</option>
        <option value="LEADER">LEADER</option>
        <option value="MEMBER">MEMBER</option>
      </select>
      <div class="msg-error" v-if="crudForm.errors.role">{{ crudForm.errors.role[0] }}</div>
    </div>

    <div class="mb-3" v-if="!crudForm.is_admin">
      <label>Team</label>
      <select v-model="crudForm.team_id" class="form-control" :class="{ 'border-danger': crudForm.errors.team_id }">
        <option v-if="crudForm.role == 'MANAGER'" :value="null">Tất cả</option>
        <option v-for="(team) in master.teams" :value="team.id" :key="team.id">{{ team.name }}</option>
      </select>
      <div class="msg-error" v-if="crudForm.errors.team_id">{{ crudForm.errors.team_id[0] }}</div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-sm btn-secondary" @click="$refs.crudModal.hide()">Hủy</button>
    <button class="btn btn-sm btn-primary" @click="onSaveCrud()">Lưu</button>
  </div>
</b-modal></template>